module.exports = __webpack_public_path__ + "img/btn4.0e45d4c0.png";